import React from 'react'
import L from 'leaflet'
import {
  Map as LeafletMap,
  Marker,
  Popup,
  TileLayer,
} from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import markerIcon from './marker.png'

const customIcon = new L.Icon({
  iconUrl: markerIcon,
  iconSize: [80, 80],
  iconAnchor: [40, 80],
  popupAnchor: [0, -80],
})

const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
const OSM_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'

export function Map({ center, zoom = 17, markerPosition, ...rest }) {
  const pos = center ? [center.lat, center.lng] : [41.4999637, -7.64]
  const markerPos = markerPosition
    ? [markerPosition.lat, markerPosition.lng]
    : pos

  return (
    <LeafletMap
      center={pos}
      zoom={zoom}
      style={{ height: '100%', width: '100%' }}
      {...rest}
    >
      <TileLayer attribution={OSM_ATTRIBUTION} url={OSM_URL} />
      <Marker position={markerPos} icon={customIcon}>
        <Popup>Solmar Limpezas</Popup>
      </Marker>
    </LeafletMap>
  )
}
